import { importClass } from "../../utilities/dynamicImportsUtility";

export default class CouponWidget extends HTMLElement {
  public constructor() {
    super();
  }

  public connectedCallback() {
    console.debug("Coupon Widget registered");
    if (document.readyState === "loading") {
      window.addEventListener("DOMContentLoaded", () => this.initialize());
    } else {
      this.initialize();
    }
  }

  private async initialize() {
    importClass(
      () =>
        import(
          /* webpackChunkName: "couponWidgetController" */ "./couponWidgetController"
        ),
      true,
      new Array<HTMLElement>(this)
    );
  }
}

customElements.define("coupon-widget", CouponWidget);
